window.GMap ?= {}

GMap.Markers = (googleMaps) ->

  googleMaps: googleMaps

  makeMarkers: (markerData) ->
    @markers = []

    for marker in markerData
      locationMarker =
        currentIndex: 0
        coloredMarkers: []

      for icon in marker.icons
        markerOptions =
          position: new @googleMaps.LatLng marker.lat, marker.lng
          icon:
            url: icon.url
            scaledSize: new @googleMaps.Size(marker.size.width, marker.size.height) if marker.size

        locationMarker.coloredMarkers.push {
          color: icon.color
          dynamicMarker: new @googleMaps.Marker markerOptions
        }

      @markers.push locationMarker

  createBounds: (markers) ->
    bounds = new @googleMaps.LatLngBounds()
    for marker in markers
      bounds.extend marker.getPosition()

    bounds

  connectMapToMarkers: (map, markers) ->
    for marker in markers
      marker.setMap map

  addMarkersToMap: (map) ->
    activeMarkers = []
    for marker in @markers
      activeMarkers.push marker.coloredMarkers[0].dynamicMarker

    @connectMapToMarkers map, activeMarkers

    if activeMarkers.length > 1
      bounds = @createBounds activeMarkers
      map.fitBounds bounds

  toggleMarkerColor: (i) ->
    return if i < 0

    marker = @markers[i]

    oldMarker = marker.coloredMarkers[marker.currentIndex].dynamicMarker
    marker.currentIndex = (marker.currentIndex + 1) % marker.coloredMarkers.length
    newMarker = marker.coloredMarkers[marker.currentIndex].dynamicMarker

    map = oldMarker.getMap()
    oldMarker.setMap null
    newMarker.setMap map

module.exports = GMap.Markers
